import { useState } from "react";
import { ArrowRight, Trophy, X } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { useShopSettings } from "../lib/shopSettings";
import { ELink } from "./Editable";

// Bandeau « Forfaits Tournoi » — affiché sous le bandeau promo (ex. WELCOME10) en
// haut de l'accueil. Balayage scintillant or brillant périodique (effet bouton doré).
// Masquable par le visiteur (X, mémorisé) et par l'admin (Paramètres → Pages et sections).
export default function ForfaitBanner() {
  const { t, ts } = useLang();
  const shopSettings = useShopSettings();
  const [closed, setClosed] = useState(() => {
    try { return localStorage.getItem("bandeau_forfaits_closed") === "1"; } catch { return false; }
  });
  if (closed) return null;
  const dismiss = () => {
    try { localStorage.setItem("bandeau_forfaits_closed", "1"); } catch { /* noop */ }
    setClosed(true);
  };
  // Image DESSINÉE PAR GEMINI (demande du propriétaire, 2026-10-27) : fondue à
  // droite du bandeau, sous le texte — réglée dans Paramètres → Pièces & bannière
  const img = shopSettings?.forfait_banner_img;
  return (
    <div data-testid="forfait-banner"
      className="relative overflow-hidden border-y-2 border-gold/60 bg-gradient-to-r from-gold/25 via-[#241d0e] to-gold/25 shadow-[0_0_28px_rgba(212,175,55,0.22)]">
      {img && (
        <div aria-hidden data-testid="forfait-banner-img"
          className="pointer-events-none absolute inset-y-0 right-0 w-2/3 opacity-45"
          style={{
            backgroundImage: `url(${process.env.REACT_APP_BACKEND_URL}/api/files/${img})`,
            backgroundSize: "cover", backgroundPosition: "center right",
            maskImage: "linear-gradient(to left, black 25%, transparent 85%)",
            WebkitMaskImage: "linear-gradient(to left, black 25%, transparent 85%)",
          }} />
      )}
      {/* balayage scintillant or brillant (décoratif) */}
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div className="bandeau-scintille absolute -top-1/2 -bottom-1/2 w-1/3 bg-gradient-to-r from-transparent via-[rgba(255,231,150,0.45)] to-transparent" />
      </div>
      <style>{`
        @keyframes bandeau-scintille {
          0% { transform: translateX(-160%) skewX(-20deg); opacity: 0; }
          12% { opacity: 1; }
          55% { transform: translateX(430%) skewX(-20deg); opacity: 1; }
          62% { opacity: 0; }
          100% { transform: translateX(430%) skewX(-20deg); opacity: 0; }
        }
        .bandeau-scintille { animation: bandeau-scintille 3.4s ease-in-out infinite; }
      `}</style>
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-center">
        <span className="inline-flex items-center gap-2.5 text-gold">
          <Trophy className="w-5 h-5" />
          <strong className="font-serif text-lg">{t("forfaitBanner.title")}</strong>
        </span>
        <span className="text-sm text-ivory/80">{t("forfaitBanner.text")}</span>
        <ELink editPath="link.forfait_banner" to="/forfaits" data-testid="forfait-banner-cta"
          className="group inline-flex items-center gap-2 bg-gold text-ink font-bold px-6 py-2.5 rounded-full text-sm hover:shadow-[0_0_22px_rgba(255,220,120,0.55)] transition-all duration-300">
          {t("forfaitBanner.cta")}
          <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
        </ELink>
      </div>
      <button onClick={dismiss} data-testid="forfait-banner-close" title={ts("forfaitBanner.close")}
        className="absolute top-2.5 right-3 z-10 text-ivory/40 hover:text-gold transition-colors">
        <X size={16} />
      </button>
    </div>
  );
}
